import { useCallback, useMemo, useRef } from "react";

import { useAuth } from "../auth/useAuth";
import { useRuntimeConfig } from "../config/useRuntimeConfig";
import { createDocumentServiceClient } from "../documents/client";
import { resolveMedicineOrdersFolderId } from "./prescriptionFolder";

export function useMedicineOrdersFolder() {
  const auth = useAuth();
  const config = useRuntimeConfig();
  const apiBaseUrl = config?.documentService?.apiBaseUrl;

  const client = useMemo(() => {
    if (!apiBaseUrl) {
      return null;
    }

    return createDocumentServiceClient(apiBaseUrl, () => auth.user?.access_token);
  }, [apiBaseUrl, auth.user]);

  // Resolved at most once per mounted order form -- repeated file selections in the same session
  // reuse the same folder rather than each racing their own "find or create".
  const cachedFolderId = useRef<string | null | undefined>(undefined);

  const ensureFolder = useCallback(async () => {
    if (!client) {
      return null;
    }

    if (cachedFolderId.current === undefined) {
      cachedFolderId.current = await resolveMedicineOrdersFolderId(client);
    }

    return cachedFolderId.current;
  }, [client]);

  return { ensureFolder };
}
